<template>
  <vx-card>
    <!-- <div class="vx-col w-full mb-base"> -->
      <!-- <h4 class="mb-2" v-if="$acl.check('accountmanager')">Modifier</h4> -->
      <div class="vx-row w-full" v-if="$acl.check('accountmanager')"> <!-- Changer avec un ACL -->
        <div class="vx-col">
          <vs-button
            color="#08B0B9"
            type="filled"
            @click="showTopKeywordEditorPopup"
          ><span style="display: inline-flex;"><vs-icon icon="font_download" size="small" /><span style="padding-top: 2px; padding-left: 5px;" >Top Keywords</span></span></vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            color="#08B0B9"
            type="filled"
            class="ml-4"
            style="height: 39px;"
            @click="showCompetitorEditorPopup"

          ><span style="display: inline-flex;"><vs-icon icon="groups" size="small" /><span style="padding-top: 2px; padding-left: 5px;" >Concurrents</span></span></vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            color="#08B0B9"
            type="filled"
            class="ml-4"
            @click="showBrandEditorPopup"
          ><span style="display: inline-flex;"><vs-icon icon="copyright" size="small" /><span style="padding-top: 2px; padding-left: 5px;" >Marques du client</span></span></vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            id="refreshButton"
            color="#0c293d"
            type="filled"
            class="ml-4 vs-con-loading__container"
            @click="refreshData"
          ><span style="display: inline-flex;"><vs-icon icon="refresh" size="small" /><span style="padding-top: 2px; padding-left: 5px;" >Actualisation des données</span></span></vs-button>
        </div>
        <div class="vx-col pt-2" v-if="last_update">
          <strong>Dernière mise à jour des données : {{ last_update }}</strong>
        </div>
      </div>
      <!-- <h4 class="mt-4">Filtrer</h4>
      <div class="vx-row w-full">
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card0', !card0)" :value="card0">Performances VS Mois précédent</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card1', !card1)" :value="card1">Position des Keywords dans Google</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card2', !card2)" :value="card2">Valeur du SEO par Top Keywords</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card3', !card3)" :value="card3">Performance des Keywords</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card4', !card4)" :value="card4">Valeur totale du SEO</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card5', !card5)" :value="card5">Evolution des positions des Top Keywords</vs-checkbox></div>
        <div class="vx-col mt-2"><vs-checkbox @click="$emit('update:card6', !card6)" :value="card6">Keywords Marques VS Génériques</vs-checkbox></div>
      </div> -->
    <!-- </div> -->
    <TopKeywordEditorPopup
      :society="society"
      :popupActive="propShowTopKeywordEditor"
      :topKeywords="topKeywords"
      @close-popup="closePopup"
      @updated-top-keywords="onSaveTke($event)"
    />
    <CompetitorEditorPopup
      :society="society"
      :popupActive="propShowCompetitorEditor"
      :competitors="competitors"
      @close-popup="closePopup"
      @updated-competitors="onSaveCps($event)"
    />
    <BrandEditorPopup
      :society="society"
      :popupActive="propShowBrandEditor"
      :brands="brands"
      @close-popup="closePopup"
      @updated-brands="onSaveBrs($event)"
    />
    <!-- <TopKeywordPopup
      :society="society"
      :popupActive="propShowTopKeywordEditor"
      :topKeywords="topKeywords"
      @closePopup="onCloseTke"
      @updated-top-keywords="onSaveTke($event)"
      @selected-action="closePopup"
    />
    <CompetitorPopup
      :society="society"
      :popupActive="propShowCompetitorEditor"
      :competitors="competitors"
      @closePopup="onCloseTke"
      @updated-competitors="onSaveCps($event)"
      @selected-action="closePopup"
    />
    <BrandPopup
      :society="society"
      :popupActive="propShowBrandEditor"
      :brands="brands"
      @closePopup="onCloseTke"
      @updated-brands="onSaveBrs($event)"
      @selected-action="closePopup"
    /> -->
  </vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import sortingMixin from "@/mixins/sortingMixin";
import chartsMixin from "@/mixins/chartsMixin";
/*
 * import TopKeywordPopup from "@/components/popups/TopKeywordPopup";
 * import CompetitorPopup from "@/components/popups/CompetitorPopup";
 * import BrandPopup from "@/components/popups/BrandPopup";
 */
import TopKeywordEditorPopup from "@/components/popups/TopKeywordEditorPopup";
import CompetitorEditorPopup from "@/components/popups/CompetitorEditorPopup";
import BrandEditorPopup from "@/components/popups/BrandEditorPopup";

export default {
	name: "TopKeywordsFilter",
	props: {
		topKeywords: Array,
		competitors: Array,
		brands: Array,
		society: Object,
		apiLastUpdate: Object,
		last_update: String,
		card0: Boolean,
		card1: Boolean,
		card2: Boolean,
		card3: Boolean,
		card4: Boolean,
		card5: Boolean,
		card6: Boolean,
	},
	mixins: [dbFieldConvertor, utilsMixin, sortingMixin, chartsMixin],
	components: {
		TopKeywordEditorPopup,
		CompetitorEditorPopup,
		BrandEditorPopup
	},

	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			currentUser: VueCookies.get("userInfo"),
			propKeywordInfo: null,
			propKeywordData: null,
			propKeywordChartParam: null,
			propShowPopup: false,
			propShowTopKeywordEditor: false,
			propShowCompetitorEditor: false,
			propShowBrandEditor: false,
			// last_update: null,
		};
	},

	created() {
		/*
		 * if(this.$props.apiLastUpdate){
		 *   let lastUpdate = this.$props.apiLastUpdate.gsc < this.$props.apiLastUpdate.ads ? this.$props.apiLastUpdate.ads : this.$props.apiLastUpdate.gsc
		 *   lastUpdate = lastUpdate < this.$props.apiLastUpdate.georanker ? this.$props.apiLastUpdate.georanker : lastUpdate
		 *   this.last_update = lastUpdate.toISOString().substring(1,10).split('-').reverse().join('/')
		 *   //console.log("this.last_update", this.last_update)
		 * }
		 */
	},

	watch: {
		/*
		 * apiLastUpdateBool: function(data){
		 *   let lastUpdate = this.$props.apiLastUpdate.gsc < this.$props.apiLastUpdate.ads ? this.$props.apiLastUpdate.ads : this.$props.apiLastUpdate.gsc
		 *   lastUpdate = lastUpdate < this.$props.apiLastUpdate.georanker ? this.$props.apiLastUpdate.georanker : lastUpdate
		 *   this.last_update = lastUpdate.toISOString().substring(1,10).split('-').reverse().join('/')
		 * }
		 */
	},

	methods: {
		resetPopup(){
			this.propShowTopKeywordEditor = false;
			this.propShowCompetitorEditor = false;
			this.propShowBrandEditor = false;
		},
		/**
		 * When a user click on a keyword, a popup shows up and display information about it
		 * @param {string} value - keyword to check
		 */
		showKeywordInfo(value) {
			this.propKeywordInfo = value;
			let keyword = value.keys[0];
			let keywordData = null;
			let keywordPos = [];
			let chartParam = {
				imp: {data: [], name: "Impressions"},
				clicks: {data: [], name: "Clics"},
				pos: {data: [], name: "Position"}
			};
			this.$vs.loading();
			setTimeout(() => this.$vs.loading.close(), 2000);
			this.$http
				.post(this.apiUrl + "webmaster/specifickeywordrank", {
					url: this.$props.society.gsc_url,
					keyword: keyword
				})
				.then(res => {
					let data = res.data.data;
					keywordPos = this.sortOneKeywordPosition(data, keyword);
					chartParam.imp.data = keywordPos.imp;
					chartParam.clicks.data = keywordPos.clicks;
					chartParam.pos.data = keywordPos.pos;
					this.propKeywordData = keywordPos;
					this.propKeywordChartParam = this.setLineAreaChartOptionsV2(
						chartParam,
						null,
						null
					);
					setTimeout(() => (this.propShowPopup = true), 1000);
				})
				.catch(err => console.error(err));
		},
		/**
		 * Opens the topkeyword editor popup
		 */
		showTopKeywordEditorPopup() {
			this.propShowCompetitorEditor = false;
			this.propShowBrandEditor = false;
			if(this.propShowTopKeywordEditor == true) {
				this.propShowTopKeywordEditor = false; // Happens if the clicks on the "x" Button
			}
			this.propShowTopKeywordEditor = true;
		},

		showCompetitorEditorPopup() {
			this.propShowTopKeywordEditor = false;
			this.propShowBrandEditor = false;
			if(this.propShowCompetitorEditor == true) {
				this.propShowCompetitorEditor = false; // Happens if the clicks on the "x" Button
			}
			this.propShowCompetitorEditor = true;
		},

		showBrandEditorPopup(){
			this.propShowCompetitorEditor = false;
			this.propShowTopKeywordEditor = false;
			if(this.propShowBrandEditor == true) {
				this.propShowBrandEditor = false; // Happens if the clicks on the "x" Button
			}
			this.propShowBrandEditor = true;
		},

		/**
		 * When the user save the topkeyword from the popup, updates the topkeywords
		 * (TKE == TOP KEYWORD EDITOR)
		 * @param {*} value - Value from the event (on save)
		 */
		onSaveTke(top_keywords) {
			//console.log("onSaveTke");
			this.$emit("updated-top-keywords", top_keywords);
			this.$emit("updateTopKeywordData", true);
		},

		onSaveCps(competitors) {
			//console.log("onSaveCps");
			this.$emit("updated-competitors", competitors);
			this.$emit("updateCompetitorsData", true);
		},

		onSaveBrs(brands) {
			//console.log("onSaveBrs");
			this.$emit("updated-brands", brands);
			this.$emit("updateBrandsData", true);
		},

		/**
		 * When the user clicks on Annuler Or Sauvegarder button, it closes the popup
		 * @param {boolean} value - Value from the event (on save)
		 */
		onCloseTke(value) {
			//console.log("onCloseTke");
			this.propShowTopKeywordEditor = value;
		},
		closePopup(){
			this.$emit("close-popup", false);
			this.propShowTopKeywordEditor = false;
			this.propShowCompetitorEditor = false;
			this.propShowBrandEditor = false;
		},

		/**
		 * When the user gives a csv file
		 * Assign new topkeywords and new top keywords data
		 * Update society's topkeywords in the database
		 * @param {object} event - Object receive
		 */
		fileUploaded(event) {
			//console.log("fileUploaded");
			let currentSociety = this.$props.society;
			let reader = new FileReader();
			reader.readAsText(event.target.files[0], "UTF-8");
			reader.onload = e => {
				let result = e.target.result.replace(/\s*,\s*/g, ",").split(",");
				let current = JSON.parse(currentSociety.topkeywords);
				const final = JSON.stringify(current.concat(result)); // Concat the two arrays and remove duplicate entries And convert it into JSON
				currentSociety.topkeywords = final;
				this.$emit("updatedSociety", currentSociety);
				this.$emit("updateTopKeywordData", true);
			};
		},
		refreshData(){
			this.$vs.loading({
				container: "#refreshButton",
				scale: 0.6
			});
			/*
			 * this.$emit('launch-loader')
			 * apiLastUpdate
			 */
			let today = new Date(Date.now());
			let todayCheck = new Date(today.toISOString().substring(0, 10));
			let queries = [];
			let apiLastUpdate_updated = {
				gsc: this.apiLastUpdate.gsc,
				ads: this.apiLastUpdate.ads,
				georanker: this.apiLastUpdate.georanker,
			};
			//console.log("this.apiLastUpdate", this.apiLastUpdate);
			//console.log(this.apiLastUpdate.gsc, todayCheck, today);
			if(this.apiLastUpdate.gsc < todayCheck){
				//console.log("Load update GSC");
				queries.push(this.$http.post(this.apiUrl + "webmaster/updateGscSociety", {
					url: this.$props.society.gsc_url,
					society_id: this.$props.society.id,
					year: today.getFullYear()
				}));
				/*
				 * this.$http.post(this.apiUrl + "webmaster/keywordYpM", {
				 *   url: this.$props.society.gsc_url,
				 *   society_id: this.$props.society.id,
				 *   year: today.getFullYear()
				 * })
				 */
				apiLastUpdate_updated.gsc = todayCheck;
			}
			else{
				//console.log("GSC already updated");
			}

			if(this.apiLastUpdate.ads < todayCheck){
				//console.log("Load update ADS");
				// queries.push(this.$http.get(this.apiUrl + "cron/exec/ads/" + this.$props.society.id))
				this.$http.get(this.apiUrl + "cron/exec/ads/" + this.$props.society.id);
				apiLastUpdate_updated.ads = todayCheck;
			}
			else{
				//console.log("ADS already updated");
			}

			if(this.apiLastUpdate.georanker < todayCheck){
				//console.log("Load update GRK");
				this.$http.post(this.apiUrl + "georanker/update/serp/society", {
					society_id: this.$props.society.id,
					searchEngine: "google",
				});
				apiLastUpdate_updated.georanker = todayCheck;
			}
			else{
				//console.log("GRK already updated");
			}

			Promise.all(queries)
				.then(responses => {
					//console.log(responses);
					this.$vs.notify({
						title: "Succès",
						text: "La demande d'actualisation a été effectuée, revenez dans quelques minutes pour observer l'avancée."
					});
					this.$emit("stop-loader");
					// this.$emit("refresh-data", apiLastUpdate_updated)
					this.$vs.loading.close("#refreshButton > .con-vs-loading");
					this.$emit("update-api-date", apiLastUpdate_updated);
				})
				.catch(error => {
					//console.log("Error: " + error);
				});
			// .catch(err => console.error(err));
		}
	}
};
</script>

<style scoped>
.text_click {
  color: #7367f0;
}
.text_imp {
  color: #55dd92;
}
.text_ctr {
  color: #ea5455;
}
.text_pos {
  color: #ff9f43;
}

.global_value {
  font-size: 22px;
  font-weight: bold;
}
.commentary {
  word-break: break-word;
}

.bgcolor {
  background-color: #383080;
}

.txt_align_right {
  text-align: right;
}

.white-txt {
  color: white;
}
.pointer {
  cursor: pointer;
}
</style>
